module.exports = __webpack_public_path__ + "img/garden-before.f711a4ea.jpg";